module.exports = {
    "Empty": `Leeg`
};


//# sourceMappingURL=nl-NL.main.js.map
